export default {
  path: '/help_center',
  name: 'helpCenter',
  meta: {
    title: '帮助中心',
    keepAlive: true
  },
  component: resolve => require(['@/views/helpCenter/Index.vue'], resolve),
}
